export default {"src":"/_next/static/media/room-category-lagoon-active.ee61cd96.svg","height":48,"width":48};